import mapPinSvg from '../../../../assets/map-pin.svg';
import { MarkerFactory } from '../PcaMap';

interface Coordinate {
  latitude: number;
  longitude: number;
}

export const mapPinToMarkerFactory: (coordinate: Readonly<Coordinate>) => MarkerFactory = ({
  latitude: lat,
  longitude: lng,
}) => {
  return ({ google, map }) => {
    /**
     * Can use https://snazzymaps.com/build-a-map to find anchor point.
     * Please compare the anchor point of custom marker with the default google marker.
     */
    const anchorPoint = new google.maps.Point(43, 58);
    return new google.maps.Marker({
      map,
      position: { lat, lng },
      icon: {
        url: mapPinSvg,
        anchor: anchorPoint,
      },
      clickable: false,
    });
  };
};
